import { render, staticRenderFns } from "./getpassword.vue?vue&type=template&id=da137164&"
import script from "./getpassword.vue?vue&type=script&lang=js&"
export * from "./getpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports